const state = {
  tooltip: null,
  hoveringTooltip: null,
};

export default state;
